"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInForm = SignInForm;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../constants/routes");
var auth_1 = require("../../features/apis/auth");
var client_1 = require("../../features/slices/client");
var user_1 = require("../../features/slices/user");
var hooks_1 = require("../../store/hooks");
var api_error_message_1 = require("../../utils/api-error-message");
var auth_storage_1 = require("../../utils/auth-storage");
var client_storage_1 = require("../../utils/client-storage");
var legal_acceptance_1 = require("../../utils/legal-acceptance");
var button_component_1 = require("../ui/button-component");
var text_component_1 = require("../ui/text-component");
var legal_acceptance_checkbox_1 = require("./legal-acceptance-checkbox");
function SignInForm() {
    var _this = this;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, hooks_1.useAppDispatch)();
    var initialFormState = {
        email: "",
        password: "",
    };
    var _a = (0, react_2.useState)(initialFormState), form = _a[0], setForm = _a[1];
    var _b = (0, react_2.useState)({}), errors = _b[0], setErrors = _b[1];
    var _c = (0, react_2.useState)(function () { return ((0, auth_storage_1.hasSessionExpired)() ? "Your session has expired and you have been logged out. Please sign in again." : ""); }), formError = _c[0], setFormError = _c[1];
    // Set only once the API asks for acceptance — first sign-in, or after the Terms/Privacy Policy change.
    var _d = (0, react_2.useState)(null), requiredLegalVersion = _d[0], setRequiredLegalVersion = _d[1];
    var _e = (0, react_2.useState)(false), hasAcceptedLegalTerms = _e[0], setHasAcceptedLegalTerms = _e[1];
    var _f = (0, react_2.useState)(false), keepSignedIn = _f[0], setKeepSignedIn = _f[1];
    var _g = (0, auth_1.useLoginMutation)(), login = _g[0], isLoading = _g[1].isLoading;
    (0, react_2.useEffect)(function () {
        (0, auth_storage_1.clearSessionExpired)();
    }, []);
    var validate = function () {
        var nextErrors = {};
        if (!form.email)
            nextErrors.email = "Email is required";
        if (!form.password)
            nextErrors.password = "Password is required";
        setErrors(nextErrors);
        return Object.keys(nextErrors).length === 0;
    };
    var handleSignIn = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, session, now, requestError_1, nextRequiredLegalVersion;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setFormError("");
                    if (!validate() || (requiredLegalVersion && !hasAcceptedLegalTerms))
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, login({
                            email: form.email,
                            password: form.password,
                            acceptedLegalVersion: requiredLegalVersion !== null && requiredLegalVersion !== void 0 ? requiredLegalVersion : undefined,
                            keepSignedIn: keepSignedIn,
                        }).unwrap()];
                case 2:
                    response = _b.sent();
                    if (!response.success || !response.content) {
                        setFormError((_a = response.message) !== null && _a !== void 0 ? _a : "Unable to sign in. Please check your details and try again.");
                        return [2 /*return*/];
                    }
                    // The active client is scoped to the signed-in user: clear any leftover
                    // selection from a previous session before this one gets evaluated.
                    (0, client_storage_1.clearClientSession)();
                    dispatch((0, client_1.clearClient)());
                    session = __assign(__assign({}, (0, auth_storage_1.toAuthSession)(response.content)), { keepSignedIn: keepSignedIn });
                    now = Date.now();
                    (0, auth_storage_1.saveLastActivity)(now);
                    (0, auth_storage_1.saveLastHeartbeat)(now);
                    (0, auth_storage_1.saveAuthSession)(session);
                    dispatch((0, user_1.setCredentials)(session));
                    navigate(routes_1.ROUTES.VALIDATE_ACCOUNT);
                    return [3 /*break*/, 4];
                case 3:
                    requestError_1 = _b.sent();
                    nextRequiredLegalVersion = (0, legal_acceptance_1.getRequiredLegalVersion)(requestError_1);
                    if (nextRequiredLegalVersion) {
                        setRequiredLegalVersion(nextRequiredLegalVersion);
                        setHasAcceptedLegalTerms(false);
                    }
                    setFormError((0, api_error_message_1.getApiErrorMessage)(requestError_1, "Something went wrong while signing in. Please try again."));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex w-full flex-col gap-4", children: [(0, jsx_runtime_1.jsxs)(react_1.TextField, { type: "email", value: form.email, onChange: function (value) { return setForm(function (prev) { return (__assign(__assign({}, prev), { email: value })); }); }, isInvalid: !!errors.email, fullWidth: true, children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "xsmall", weight: "medium", color: "dark-gray-1", label: "Email Address" }), (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "your@email.com", className: "auth-field rounded-md border-gray-300 shadow-sm" }), errors.email && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: errors.email }) }))] }), (0, jsx_runtime_1.jsxs)(react_1.TextField, { type: "password", value: form.password, onChange: function (value) { return setForm(function (prev) { return (__assign(__assign({}, prev), { password: value })); }); }, isInvalid: !!errors.password, fullWidth: true, children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "xsmall", weight: "medium", color: "dark-gray-1", label: "Password" }), (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "Password", className: "auth-field rounded-md border-gray-300 shadow-sm" }), errors.password && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: errors.password }) }))] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between", children: [(0, jsx_runtime_1.jsxs)(react_1.Checkbox, { id: "keep-signed-in", isSelected: keepSignedIn, onChange: setKeepSignedIn, isDisabled: isLoading, className: "group flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(react_1.Checkbox.Control, { className: "border border-primary-navy group-data-[selected=true]:!bg-white", children: (0, jsx_runtime_1.jsx)(react_1.Checkbox.Indicator, { className: "!text-primary-navy" }) }), (0, jsx_runtime_1.jsx)(react_1.Checkbox.Content, { children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "dark-gray-1", label: "Keep me signed in" }) })] }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: routes_1.ROUTES.FORGOT_PASSWORD, className: "text-sm font-semibold text-primary-navy hover:underline", children: "Forgot password?" })] }), requiredLegalVersion && (0, jsx_runtime_1.jsx)(legal_acceptance_checkbox_1.LegalAcceptanceCheckbox, { isAccepted: hasAcceptedLegalTerms, onChange: setHasAcceptedLegalTerms, isDisabled: isLoading }), formError && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: formError }) })), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Sign In", onPress: handleSignIn, isPending: isLoading, isDisabled: !!requiredLegalVersion && !hasAcceptedLegalTerms, color: "white", backgroundColor: "primary-navy", hoverColor: "primary-navy-light", className: "w-full py-2.5" })] }));
}
